import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transparencia',
  templateUrl: './transparencia.component.html',
  styleUrls: ['./transparencia.component.css']
})
export class TransparenciaComponent implements OnInit {
  eje2021 = false;
  eje2022 = false;
  eje2023 = false;
  eje2024 = false;
  eje2025 = false;
  normatividad2024= false



  // Estados de acordeones

  disciplinaFinanciera: boolean = false;
  ramo28: boolean = false;
  presupuesto: boolean = false;
  invitacion: boolean = false;
  anexos: boolean = false;
  juntaAclaraciones: boolean = false;
  presentacionOfertas: boolean = false;
  fallo: boolean = false;
  invitacionCAP: boolean = false;

  // Datos de años para RAMO 33
  years = [
    {
      id: 2021,
      year: 2021,
      expanded: false,
      trimestres: [
        { label: 'Primer Trimestre 2021', url: 'https://nld.gob.mx/assets/ramo33/1er%20Informe%20trismestral%202021.pdf' },
        { label: 'Segundo Trimestre 2021', url: 'https://nld.gob.mx/assets/ramo33/2do%20Informe%20trimestral%202021.pdf' },
        { label: 'Tercer Trimestre 2021', url: 'https://nld.gob.mx/assets/ramo33/3%20informe%20trimestral.pdf' },
        { label: 'Cuarto Trimestre 2021', url: 'https://nld.gob.mx/assets/ramo33/4%20informe%20trimestral%202021.pdf' }
      ]
    },
    {
      id: 2022,
      year: 2022,
      expanded: false,
      trimestres: [
        { label: 'Primer Trimestre 2022', url: 'https://nld.gob.mx/assets/ramo33/1_2022.pdf' },
        { label: 'Segundo Trimestre 2022', url: 'https://nld.gob.mx/assets/ramo33/2_2022.pdf' },
        { label: 'Tercer Trimestre 2022', url: 'https://nld.gob.mx/assets/ramo33/3_2022.pdf' },
        { label: 'Cuarto Trimestre 2022', url: 'https://nld.gob.mx/assets/ramo33/4_2022.pdf' }
      ]
    },
    {
      id: 2023,
      year: 2023,
      expanded: false,
      trimestres: [
        { label: 'Primer Trimestre 2023', url: 'https://nld.gob.mx/assets/ramo33/1_2023.pdf' },
        { label: 'Segundo Trimestre 2023', url: 'https://nld.gob.mx/assets/ramo33/2_2023.pdf' },
        { label: 'Tercer Trimestre 2023', url: 'https://nld.gob.mx/assets/ramo33/3_2023.pdf' },
        { label: 'Cuarto Trimestre 2023', url: 'https://nld.gob.mx/assets/ramo33/4_2023.pdf' }
      ]
    },
    {
      id: 2024,
      year: 2024,
      expanded: false,
      trimestres: [
        { label: 'Primer Trimestre 2024', url: 'https://nld.gob.mx/assets/ramo33/1_2024.pdf' },
        { label: 'Segundo Trimestre 2024', url: 'https://nld.gob.mx/assets/ramo33/2_2024.pdf' },
        { label: 'Tercer Trimestre 2024', url: 'https://nld.gob.mx/assets/ramo33/3_2024.pdf' },
        { label: 'Cuarto Trimestre 2024', url: 'https://nld.gob.mx/assets/ramo33/4_2024.pdf' }
      ]
    },
    {
      id: 2025,
      year: 2025,
      expanded: false,
      trimestres: [
        { label: 'Primer Trimestre 2025', url: 'https://nld.gob.mx/assets/ramo33/1_2025.pdf' },
        { label: 'Segundo Trimestre 2025', url: 'https://nld.gob.mx/assets/ramo33/2_2025.pdf' },
        { label: 'Tercer Trimestre 2025', url: 'https://nld.gob.mx/assets/ramo33/3_2025.pdf' },
        { label: 'Cuarto Trimestre 2025', url: 'https://nld.gob.mx/assets/ramo33/4_2025.pdf' }
      ]
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }
/*
  expandeNormatividad() {
console.log(this.normatividad2024)
    if (this.normatividad2024 == true) {
      this.normatividad2024 = false;


    }
    if (this.normatividad2024 == false) {
      this.normatividad2024 = true;


    }
  }

  expande2021(){
     
    if (this.eje2021 == true){
      this.eje2021 = false;
      

    }
    if (this.eje2021 == false) {
      this.eje2021 = true;

    }
  }
  expande2022() {

    if (this.eje2022 == true) {
      this.eje2022 = false;

    }
    if (this.eje2022 == false) {
      this.eje2022 = true;

    }
  }
  expande2023() {

    if (this.eje2023 == true) {
      this.eje2023 = false;

    }
    if (this.eje2023 == false) {
      this.eje2023 = true;

    }
  }
  expande2024() {

    if (this.eje2024 == true) {
      this.eje2024 = false;

    }
    if (this.eje2024 == false) {
      this.eje2024 = true;

    }
  }

  expande2025() {

    if (this.eje2025 == true) {
      this.eje2025 = false;

    }
    if (this.eje2025 == false) {
      this.eje2025 = true;

    }
  }*/

  toggleNormatividad(): void {
    this.normatividad2024 = !this.normatividad2024;
  }

  // Toggle para Disciplina Financiera
  toggleDisciplina(): void {
    this.disciplinaFinanciera = !this.disciplinaFinanciera;
  }

  // Toggle para Ramo 28
  toggleRamo28(): void {
    this.ramo28 = !this.ramo28;
  }

  // Toggle para Presupuesto
  togglePresupuesto(): void {
    this.presupuesto = !this.presupuesto;
  }

  // Toggle para Invitación
  toggleInvitacion(): void {
    this.invitacion = !this.invitacion;
  }

  // Toggle para Anexos
  toggleAnexos(): void {
    this.anexos = !this.anexos;
  }

  // Toggle para Junta de Aclaraciones
  toggleJuntaAclaraciones(): void {
    this.juntaAclaraciones = !this.juntaAclaraciones;
  }

  // Toggle para Presentación y Apertura de Ofertas
  togglePresentacionOfertas(): void {
    this.presentacionOfertas = !this.presentacionOfertas;
  }

  // Toggle para Fallo
  toggleFallo(): void {
    this.fallo = !this.fallo;
  }

  // Toggle para Invitación CAP
  toggleInvitacionCAP(): void {
    this.invitacionCAP = !this.invitacionCAP;
  }

  // Toggle para años de RAMO 33
  toggleYear(yearId: number): void {
    const year = this.years.find(y => y.id === yearId);
    if (year) {
      year.expanded = !year.expanded;
    }
  }

  // Métodos legacy para compatibilidad (si existen en el componente original)
  expande2021(): void {
    this.toggleYear(2021);
  }

  expande2022(): void {
    this.toggleYear(2022);
  }

  expande2023(): void {
    this.toggleYear(2023);
  }

  expande2024(): void {
    this.toggleYear(2024);
  }

  expande2025(): void {
    this.toggleYear(2025);
  }

  expandeNormatividad(): void {
    this.toggleNormatividad();
  }
}
